import { render } from "./ajusteDispositivoModal.vue?vue&type=template&id=334c36cb&scoped=true"
import script from "./ajusteDispositivoModal.vue?vue&type=script&lang=js"
export * from "./ajusteDispositivoModal.vue?vue&type=script&lang=js"

import "./ajusteDispositivoModal.vue?vue&type=style&index=0&id=334c36cb&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334c36cb"]])

export default __exports__